import { useCallback } from "react";
import { articleSearchClient } from "services/typesense";
import { chunk } from "lodash";
import { mergeMysteryArticles } from "helpers/mysteryItem";

const useEventArticleReader = () => {
  // ids may include mystery-item ids (they live in allArticles like any
  // other id); those are resolved from the event's mysteryArticles map and
  // excluded from the Typesense fetch.
  const retrieveArticlesByIDs = useCallback(async (ids, mysteryArticles) => {
    process.env.NODE_ENV === "development" &&
      console.log("Calling to Typesense to get Articles by ID");
    if (ids == null || ids.length === 0) return {};
    const mysteryIDs =
      mysteryArticles == null ? [] : Object.keys(mysteryArticles);
    const realIDs = ids.filter((id) => !mysteryIDs.includes(id));
    try {
      let retrievedArticles = {};
      if (realIDs.length > 0) {
        const chunks = chunk(realIDs, 200);
        let searchRequests = { searches: [] };
        chunks.forEach((chunk) => {
          searchRequests.searches.push({
            collection: `${process.env.REACT_APP_TYPESENSE_COLLECTION_PREFIX}.articles`,
            filter_by: `id: [${chunk}]`
          });
        });

        // Search parameters that are common to all searches go here
        let commonSearchParams = {
          q: "*",
          per_page: 200
        };

        let result = await articleSearchClient.multiSearch.perform(
          searchRequests,
          commonSearchParams
        );

        result.results.forEach((chunk) => {
          chunk.hits.map(
            (hit) => (retrievedArticles[hit.document.id] = hit.document)
          );
        });
      }

      return mergeMysteryArticles(retrievedArticles, mysteryArticles, ids);
    } catch (error) {
      // console.log(error);
      throw error;
    }
  }, []);

  return {
    retrieveArticlesByIDs
  };
};

export default useEventArticleReader;
